import ApiService from './ApiService';

export default class CouponService {
  static findOneByCode(code) {
    return ApiService.get(`/coupons/${code}`);
  }

  findAll() {
    return ApiService.get('/coupons');
  }

  static validate(data, recaptchaToken) {
    return ApiService.post('/coupons/validate', data, { headers: { Recaptcha: recaptchaToken } });
  }
}
